import { render, staticRenderFns } from "./glossary.vue?vue&type=template&id=3a76c03f&scoped=true&"
import script from "./glossary.vue?vue&type=script&lang=js&"
export * from "./glossary.vue?vue&type=script&lang=js&"
import style0 from "./glossary.vue?vue&type=style&index=0&id=3a76c03f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a76c03f",
  null
  
)

export default component.exports